import { ReadUserStorageApiResponse } from '../types/userStorageApi.types';

import { migrateReadUserStorageResponse } from './migrations/readUserStorageResponse';

export function transformReadUserStorageResponse(
  response: any,
): ReadUserStorageApiResponse {
  return migrateReadUserStorageResponse(response);
}
